export const projects = [
  {
    title: "HR Analytics Dashboard",
    description: "Created a comprehensive Power BI dashboard analyzing employee attrition rate (16.1%), average salary, tenure, and performance metrics, enabling data-driven HR decisions.",
    image: "/assets/projects/hr-analytics.svg",
    date: "Nov 2024 – Jan 2025",
    technologies: ["Power BI", "Data Visualization", "HR Analytics", "DAX"],
    demoLink: "https://example.com/hr-analytics",
    codeLink: "https://github.com/khushbookumari15/hr-analytics"
  },
  {
    title: "Netflix Data Analysis",
    description: "Developed an interactive dashboard visualizing Netflix content trends, genre preferences, rating patterns, and global availability with country-level filters.",
    image: "/assets/projects/netflix-analysis.svg",
    date: "Jan 2025",
    technologies: ["Power BI", "Data Analysis", "Entertainment Analytics", "Visualization"],
    demoLink: "https://example.com/netflix-analysis",
    codeLink: "https://github.com/khushbookumari15/netflix-analysis"
  },
  {
    title: "Sales Performance Dashboard",
    description: "Built a dynamic sales dashboard with key performance indicators, regional breakdowns, and trend analysis to track revenue growth and identify market opportunities.",
    image: "/assets/projects/sales-dashboard.svg",
    date: "Dec 2024",
    technologies: ["Power BI", "Excel", "Sales Analytics", "Data Visualization"],
    demoLink: "https://example.com/sales-dashboard",
    codeLink: "https://github.com/khushbookumari15/sales-dashboard"
  },
  {
    title: "Customer Segmentation Analysis",
    description: "Analyzed customer behavior data to create segmentation models, identifying key customer groups based on purchasing patterns, demographics, and engagement metrics.",
    image: "/assets/projects/customer-segmentation.svg",
    date: "Oct 2024",
    technologies: ["Python", "Excel", "Data Analysis", "Clustering"],
    demoLink: "https://example.com/customer-segmentation",
    codeLink: "https://github.com/khushbookumari15/customer-segmentation"
  },
  {
    title: "E-commerce Sales Analysis",
    description: "Created an interactive dashboard to analyze e-commerce sales trends, product performance, and customer demographics to drive business strategy and marketing efforts.",
    image: "/assets/projects/ecommerce-sales.svg",
    date: "Sep 2024",
    technologies: ["Power BI", "SQL", "E-commerce Analytics", "Visualization"],
    demoLink: "https://example.com/ecommerce-analysis",
    codeLink: "https://github.com/khushbookumari15/ecommerce-analysis"
  }
];
